
import ko from 'knockout';
import * as mapping from 'knockout-mapping';
import Filters from "../filters";

let json = $("#page-data").text();
let data = mapping.fromJSON(json);

let catJson = $("#collection-data").text();
var catData = JSON.parse(catJson);

let dom = document.getElementById('products-browse');
Filters.init(data);
ko.applyBindings(data, dom);


$(function () {
    
    (window as any).klaviyo.track("Viewed Collection",{
        "CategoryName": catData.Name,
        "CategoryID": catData.Id,
        "Slug": catData.Slug
    }).then(function(e) {
        console.log('tracked collection');
    });
})